export const SORT_TYPES = {
  text: { asc: 'A \u2192 Z', desc: 'Z \u2192 A' },
  date: { asc: 'Earliest \u2192 Latest', desc: 'Latest \u2192 Earliest' },
  number: { asc: '1 \u2192 9', desc: '9 \u2192 1' },
  boolean: { asc: 'No \u2192 Yes', desc: 'Yes \u2192 No' },
  ordered: { asc: 'First \u2192 Last', desc: 'Last \u2192 First' },
  quantity: { asc: 'Lowest \u2192 Highest', desc: 'Highest \u2192 Lowest' },
};

export const EVENT_COLUMNS = [
  { id: 'title', label: 'Event', alwaysVisible: true, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'start_time', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'calendar_classification', label: 'Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'ordered' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'headliner', label: 'Headliner', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'promoter_name', label: 'Promoter', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'support_acts', label: 'Support', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'age_restriction', label: 'Ages', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'ticketing_arrangement', label: 'Ticketing', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'is_public', label: 'Public', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'boolean' },
  { id: 'presenter', label: 'Presenter', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'tickets_sold', label: 'Tickets Sold', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'quantity' },
  { id: 'tickets_scanned', label: 'Tickets Scanned', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'quantity' },
  { id: 'end_time', label: 'End Time', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'date' },
  { id: 'id', label: 'Event ID', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'number' },
];

export const getDefaultVisibleColumns = () =>
  EVENT_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  EVENT_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
